export const selectIntegrationTrelloData = state =>
  state.integrations.thirdPartyData.trello
